import {atom} from 'recoil';

const cartAtom = atom({
  key: '@cart_atom',
  default: <CartDataT>null,
});

export default cartAtom;
